<template>
<div class="feed_container">
  <div
  v-observer-log="getLogData(shop.data, index)"
  @click="openPage(shop, index)"
  :class="['feed_item']" v-for="(shop, index) in feed"
  :key="shop.data.shopId"
  :id="`id_${shop.data.shopId}`">
    <!-- 商家图 -->
    <img v-lazy="toImg(shop.data.shopImg)" class="shop_img" />
    <!-- 商家名 -->
    <div class="shop_name">{{shop.data.shopName}}</div>
    <!-- 履约信息 -->
    <div class="shop_fulfillment">
      <div class="fulfillment_item" v-for="(f, index) in shop.data.fulfillment" :key="index">
        <RichText v-if="f.icon" :class="['icon', f.content && f.content !== '' ? 'right_space' : '']" :text="f.icon" :style="'display:flex;align-items:center;'" />
        <RichText v-if="f.content" class="text" :text="f.content" />
        <div class="split_dot" v-if="index+1 < shop.data.fulfillment.length">·</div>
      </div>
    </div>
    <!-- tags -->
    <div class="tags" v-if="shop.data.tags.length > 0">
      <div v-for="(tag,index) in shop.data.tags" class="tag" :key="index">
        <i v-if="tag.icon && tag.icon !== ''" :class="iconclass(tag.icon)" />{{tag.content}}
      </div>
    </div>
    <!-- 蒙层 -->
    <div class="status_mask" v-if="shop.data.statusDesc !== '' || shop.data.bizTimeDesc !== ''"></div>
    <div class="status_name" v-if="shop.data.statusDesc !== '' || shop.data.bizTimeDesc !== ''">
      <div class="name">{{shop.data.statusDesc === '' ? shop.data.bizTimeDesc : shop.data.statusDesc}}</div>
    </div>
    <!-- 排名 -->
    <div v-if="shop.data && shop.data.honorInfo && shop.data.honorInfo.iconUrl" class="rank_img">
      <img :src="shop.data.honorInfo.iconUrl" />
    </div>
    <!-- 推荐理由 -->
    <div v-if="shop.data.recReason && shop.data.recReason.length" class="rec_reason_container_out">
      <div class="rec_reason">
        <div class="seller_item" v-for="(r, index) in shop.data.recReason" :key="index">
          <RichText v-if="r.content" :class="['top_num', index === 1 ? 'is_num' : '']" :text="r.content" />
          <img v-if="r.leftImg" :src="r.leftImg" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import RichText from '@/components/RichText';
import I18nUtil from '@didi/i18n-util';
import { getScheme, getAppType } from '@/common/js/utils'
const { getLocale } = I18nUtil;
const Scheme = `${getScheme()}://soda`
const BusiPath = '/businessPage'
export default {
  props: {
    feed: {
      type: Array,
      default: []
    },
    getObserverLogData: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    RichText,
  },
  computed: {
    
  },
  methods: {
    getLogData(shop, index) {
      const res = this.getObserverLogData(shop, index)
      return res;
    },
    iconclass(text) {
      // 客户端增加了rf前缀 后续沟通如何统一 暂时先替换前缀
      return text.replace(/^rf_icon(_|-)/, 'icon-');
    },
    imgConfig(src, config) {
      if (src.search(/\?/) !== -1) { return `${src}&${config}`}
      return `${src}?${config}`
    },
    toImg(url) {
      if (!(url && url !== '')) {
        return "https://img0.didiglobal.com/static/soda_public/do1_VnNcxUIQlvhtSHaqw7IJ";
      }
      return url;
    },
    openPage(shop, index) {
      try {
        this.$emit('traceShopCk', shop.data, index);
      } catch(err) {console.error(err)}
      const {businessType} = shop.data;
      var shopId = shop.data.shopId;
      if (businessType === 3) { //1、外卖 2、代购 3、商超
        const host = `https://www.didi-food.com/${getLocale()}`;
        this.SodaBridge('openPage', {
          target: 'blank',
          url: `${host}/grocery/shop?storeId=${shopId}&nativeWebUIType=2`,
        })
        return;
      }
      // Nacho.openPage('globalOneTravel:\/\/soda\/businessPage?shopid=${feed.data.shopId}&shopId=${feed.data.shopId}');
      this.SodaBridge('openPage', {
        target: 'blank',
        url: `${Scheme}${BusiPath}?shopid=${shopId}&shopId=${shopId}`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.feed_container {
  margin-top: -367px;
  padding: 0 32px 0 32px;
  .feed_item {
    position: relative;
    width: 638px;
    margin-bottom: 24px;
    padding: 24px 24px 32px 24px;
    background: #FFFFFF;
    box-shadow: 0px 10px 40px 0px rgba(0,0,0,0.04);
    border-radius: 40px;
    // 相对定位
    .shop_img {
      width: 638px;
      height: 320px;
      border-radius: 28px;
      object-fit: cover;
    }
    .shop_name {
      margin-top: 16px;
      width: 630px;
      height: 38px;
      font-family: DiDiSans-Pro-Bold;
      font-size: 32px;
      color: #000000;
      letter-spacing: -1px;
      font-weight: 700;
      overflow:hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow:ellipsis;
    }
    .shop_fulfillment {
      margin-top: 6px;
      display: flex;
      align-items: center;
      line-height: 29px;
      .fulfillment_item {
        font-size: 24px;
        display: flex;
        .split_dot {
          margin-left: 6px;
          margin-right: 6px;
        }
        .right_space {
          margin-right: 4px;
        }
      }
    }
    .tags {
      margin-top: 16px;
      display: flex;
      flex-wrap: wrap;
      height: 36px;
      overflow-y: hidden;
      .tag {
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.95;
        background-image: linear-gradient(270deg, #FF8040 39%, #FF5E0D 99%);
        border-radius: 12px;
        padding: 0 11.5px 0 11.5px;
        height: 36px;
        line-height: 36px;
        font-family: DiDiSans-Pro-Medium;
        font-size: 24px;
        color: #FFFFFF;
        letter-spacing: 0;
        font-weight: 500;
        margin-right: 20px;
      }
    }
    // 绝对定位
    .status_mask {
      position: absolute;
      top: 24px;
      width: 638px;
      height: 320px;
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0.4;
      background: #000000;
      border-radius: 32px;
    }
    .status_name {
      position: absolute;
      top: 24px;
      width: 638px;
      height: 320px;
      display: flex;
      justify-content: center;
      align-items: center;
      .name {
        opacity: 1;
        background: #FFFFFF;
        border-radius: 18px;
        padding: 16px 32px 16px 32px;
        font-family: DiDiSans-Pro-Medium;
        font-size: 24px;
        color: #000000;
        letter-spacing: 0;
        text-align: center;
        font-weight: 500;
      }
    }
    .rank_img {
      position: absolute;
      top: 8px;
      left: 24px;
      width: 108px;
      height: 108px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 108px;
        height: 108px;
      }
    }
    .rec_reason_container_out {
      position: absolute;
      top: 24px;
      width: fit-content;
      height: 320px;
      .rec_reason {
        position: absolute;
        left: 24px;
        bottom: 24px;
        height: 44px;
        padding: 4px 16px;
        background: rgba(0,0,0,0.80);
        border-radius: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        .top_num {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 32px;
          font-family: DiDiSans-Pro-Regular;
          font-size: 32px;
          color: #FF8040;
          letter-spacing: 0;
          font-weight: 700;
          margin-right: 8px;
          &.is_num {
            font-family: DiDiSans-Pro-Bold;
          }
        }
        img {
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }
        .seller_item {
          display: flex;
          opacity: 0.8;
          font-family: DiDiSans-Pro-Regular;
          font-size: 24px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 44px;
          font-weight: 400;
          white-space: nowrap;
          
        }
      }
    }
  }
}
</style>